import src from "IMAGE";
export default { src, width: 309, height: 108, blurWidth: 0, blurHeight: 0};
